import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var NotesIcon = (props, _ref) => {
  var {
    attrs
  } = _ref;
  var _a, _b, _c, _d, _e, _f, _g;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var {
    width,
    height
  } = props;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.618 17.501",
    width: "".concat(width),
    height: "".concat(height),
    class: (_a = props.class) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, h("g", {
    fill: (_c = attrs["fill-color"]) !== null && _c !== void 0 ? _c : "none",
    stroke: (_d = attrs["stroke-color"]) !== null && _d !== void 0 ? _d : "#2b5dff",
    "stroke-linecap": "".concat((_e = attrs["stroke-linecap"]) !== null && _e !== void 0 ? _e : "round"),
    "stroke-linejoin": "".concat((_f = attrs["stroke-linejoin"]) !== null && _f !== void 0 ? _f : "round"),
    "stroke-width": "".concat((_g = attrs["stroke-width"]) !== null && _g !== void 0 ? _g : "1.5")
  }, [h("path", {
    d: "M5.692 14.091a.312.312 0 0 1-.345-.273l-.316-3.054a.953.953 0 0 1 \n            .2-.695l7.099-8.841a1.269 1.269 0 0 1 1.784-.2h.006l2.151 1.727a1.271 1.271\n             0 0 1 .2 1.785h0l-7.1 8.839a.954.954 0 0 1-.633.351Z"
  }), h("path", {
    d: "m10.886 3.025 4.178 3.272"
  }), h("path", {
    d: "M15.869 9.57v4.981a2.2 2.2 0 0 1-2.2 2.2H2.95a2.2 2.2 0 0 1-2.2-2.2V3.827a2.2 2.2 0 0 1 2.2-2.2h4.979"
  })]));
};